import { render, staticRenderFns } from "./members-recommended.vue?vue&type=template&id=2d1bd0d5&scoped=true&"
import script from "./members-recommended.vue?vue&type=script&lang=js&"
export * from "./members-recommended.vue?vue&type=script&lang=js&"
import style0 from "./members-recommended.vue?vue&type=style&index=0&id=2d1bd0d5&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d1bd0d5",
  null
  
)

export default component.exports